// Enum for filter types
export enum FilterType {
  EXACT = 'Exact',
  RANGE = 'Range',
  CONTAINS = 'Contains',
  DISABLE = 'Disable'
}

// Type for AutoBuy parameter
export interface AutoBuyParameter {
  id?: number; // Backend ID (optional for new rules)
  tempId: string; // Temporary ID for React state management
  ticketsGoal: number;
  limitedView: boolean;
  quantity: string;
  quantityType: FilterType;
  section: string;
  sectionType: FilterType;
  row: string;
  rowType: FilterType;
  pricePoint: string;
  pricePointType: FilterType;
  isDeleted: boolean;
  ticketsGoalReached: boolean;
  accepted: number;
  completed: number;
}

// Type for AutoBuy state
export interface AutoBuyState {
  parameters: AutoBuyParameter[];
  buyManagerId: string;
}

// Type for Autobuy component props
export interface AutobuyContentProps {
  swarmId: string; // Swarm ID
  isAutoBuyActive: boolean; // Flag indicating if autobuy is active
}

// Interface for active swarm auto buy rule with ticket counters
export interface ActiveSwarmAutoBuyRule {
  id: number;
  swarmId: number;
  ticketsGoal: number;
  limitedView: boolean;
  generalAdmission: boolean;
  quantity: string;
  quantityType: FilterType;
  section: string;
  sectionType: FilterType;
  row: string;
  rowType: FilterType;
  pricePoint: string;
  pricePointType: FilterType;
  ticketsGoalReached: boolean;
  isDeleted: boolean;
  accepted: number; // Count of accepted tickets for this rule
  completed: number; // Count of completed tickets for this rule
}

// Response from getActiveSwarmRules endpoint
export interface ActiveSwarmAutoBuyRulesResponse {
  swarmId: number;
  rules: ActiveSwarmAutoBuyRule[];
}
